import { type FC, type MouseEventHandler, type ReactNode } from 'react';
import classnames from 'classnames';

import { Link, type LinkProps } from 'dibs-elements/exports/Link.tsx';
import ChevronRight from 'dibs-icons/exports/ChevronRight.ts';

import { useServerVars } from '../../../shared/ServerVarsContext.tsx';

import styles from './TradeBenefitsHeroActionLink.scss';
import dibsCss from 'dibs-css';

type Props = {
    title: ReactNode;
    description: ReactNode;
} & ({ href: string; onClick?: MouseEventHandler } | { onClick: MouseEventHandler });

const TradeBenefitsHeroActionLink: FC<Props> = props => {
    const { title, description } = props;
    const { isMobile } = useServerVars();

    const linkProps: LinkProps =
        'href' in props
            ? { href: props.href, target: '_blank', onClick: props.onClick }
            : { onClick: props.onClick };

    return (
        <Link {...linkProps} className={dibsCss.wFull} underline="none">
            <div
                className={classnames(
                    styles.link,
                    dibsCss.pySmaller,
                    dibsCss.pxSmall,
                    dibsCss.bgWhite,
                    dibsCss.roundedXsmall,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.justifyBetween
                )}
            >
                <div>
                    <div className={classnames(styles.title, dibsCss.textBodyHeaderMediumHeavy)}>
                        {title}
                    </div>
                    {!isMobile && <div className={dibsCss.textBodySmallNormal}>{description}</div>}
                </div>
                <ChevronRight variation={isMobile ? '20' : '24'} />
            </div>
        </Link>
    );
};

export { TradeBenefitsHeroActionLink };
